export const sourceSystemMap = {
  NKC: 'AnvaC90'
}
